import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import FeedbackIcon from '@/assets/feedback.svg?react';
import SuggestionIcon from '@/assets/suggestion.svg?react';
import type { IssueTypeCardProps } from './types';

const ISSUE_TYPE_ICONS = {
  bug_report: FeedbackIcon,
  feature_request: SuggestionIcon,
};

export const IssueTypeCard = ({ type, selected, onClick }: IssueTypeCardProps) => {
  const { t } = useTranslation();
  const IconComponent = ISSUE_TYPE_ICONS[type];

  // 根据类型获取翻译 key（使用接口枚举值）
  const titleKey = type === 'bug_report' ? 'feedback.issueType.feedback' : 'feedback.issueType.suggestion';
  const descKey = type === 'bug_report' ? 'feedback.issueType.feedbackDesc' : 'feedback.issueType.suggestionDesc';

  // 中文时显示: 问题反馈 (Bug Report)
  // 英文时显示: Bug Report
  const title = t(titleKey)
  const description = t(descKey);

  return (
    <div
      className={clsx(
        'flex flex-1 cursor-pointer flex-col items-start justify-center gap-0.5 rounded border-[0.6px] p-[7.4px] transition-all hover:bg-[#252526]',
        selected ? 'border-[#007acc]' : 'border-[#cccccc26]'
      )}
      onClick={onClick}
    >
      <div className="flex items-center gap-1">
        <IconComponent className="h-[14px] w-[14px] text-[#cccccc]" />
        <span className="font-pingfang text-xs leading-[18px] text-[#cccccc]">
          {title}
        </span>
      </div>
      <span className="font-pingfang text-[10px] leading-[14px] text-[#cccccc80]">
        {description}
      </span>
    </div>
  );
};
